import { MOCK_UP_LAYERS } from '../constants';
import { MockUpLayer, MockUpGradientLayer, ImageLayer, VariationLayer } from '../layers';

const { BACKGROUND_LAYER, GRADIENT_LAYER, IMAGE_LAYER, VARIATION_LAYER } = MOCK_UP_LAYERS;

export const layerMap = {
    [BACKGROUND_LAYER]: MockUpLayer,
    [GRADIENT_LAYER]: MockUpGradientLayer,
    [IMAGE_LAYER]: ImageLayer,
    [VARIATION_LAYER]: VariationLayer,
};
